import React from "react";

import Grid from "@material-ui/core/Grid";
import LockIcon from "@material-ui/icons/Lock";
import { Typography } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import useStyles from "./useStyles";

import { CreateNewPasswordPage } from "../create-new-password-page";
import { personImg } from "../../../shared/consts/imgUrls";

export const NewPassword = () => {
  const classes = useStyles();
  return (
    <div className={classes.loginContent}>
      <Container>
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Paper className={classes.paper}>
              <img
                className={classes.ribbonImage}
                src="/ribbon.svg"
                alt="Fruition Assessment"
              />
              <div className={classes.wrapperLogin}>
                <div
                  className={[classes.paper, classes.loginLeftContent].join(
                    " "
                  )}
                >
                  <div className={classes.formWrapper}>
                    <form className={classes.form} noValidate>
                      <Grid container>
                        <img
                          className={classes.character2}
                          src={personImg}
                          alt="Character 2"
                        />
                      </Grid>
                    </form>
                    <Typography
                      gutterBottom
                      variant="p"
                      component="div"
                      className={[
                        classes.center,
                        classes.top,
                        classes.spans,
                        classes.blue,
                      ].join(" ")}
                    >
                      <LockIcon className={classes.large} />
                      {` Safe.Secure.Trusted`}
                    </Typography>
                  </div>
                </div>
                <div className={classes.loginRightContent}>
                  <div className={classes.testimonialsContainer}>
                    <div className={[classes.paper, classes.billing].join(" ")}>
                      <div className={classes.formWrapper}>
                        <CreateNewPasswordPage />
                      </div>
                      <Typography
                        gutterBottom
                        variant="p"
                        component="div"
                        className={[
                          classes.center,
                          classes.top,
                          classes.spans,
                          classes.bold,
                        ].join(" ")}
                      >
                        Be sure to store password somewhere
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
